<template>
  <div class="flex gap-4 p-5 cursor-pointer" @click="$emit('showDetail')">
    <div class="float-left">
      <div class="img-item show-img" :style="{'background-image': `url(${data.imageURL})`}"> </div>
    </div>
    <div class="hotel-data">
      <div class="flex flex-wrap gap-4">
        <div class="label demo label-grey-200 text-primary">{{data.label}}</div>
        <div class="menu-id">メニューNo.{{data.menuNo}}</div>
      </div>
      <div :class="data.type">
        <h3 class="title2">{{data.menuNm}}</h3>
      </div>
      <div :class="data.type">
        <h3>{{data.planNm}}</h3>
        <div>
          <div class="meta-item">
            <i :class="data.icon" />
            <span>{{data.phone}}</span>
          </div>
        </div>
        <div class="pt-2 item-no">
          <span class="mr-3">受付番号: {{data.receiptNo}}</span>
          <span>有効期限: {{data.expireTo}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'item-order',
  components: {},
  props: {
    data: {
      type: Object
    },
    showDetail: {
      type: Function
    }
  }
}
</script>
<style lang="scss">
  @import './style.scss';
</style>